import { useEffect, useReducer } from 'react';

const invDataReducer = (state, action) => {
	switch (action.type) {
		case 'INV_DATA_INIT':
			return {
				...state,
				isLoading: true,
				isError: false
			};
		case 'INV_DATA_SUCCESS':
			return {
				...state,
				isLoading: false,
				isError: false,
				paging: action.payload
			};
		case 'INV_DATA_FAILURE':
		default:
			return {
				...state,
				isLoading: false,
				isError: true,
				paging: action.payload
			};
	}
};

export const useInventory = () => {
	const [state, dispatch] = useReducer(invDataReducer, {
		isLoading: true,
		isError: false,
		paging: null
	});

	// wait for DDC.InvData
	useEffect(() => {
		let waitForInvDataHandle;
		let inventorySubscription;
		let requestFailedSubscription;
		dispatch({ type: 'INV_DATA_INIT' });
		const checkForInvData = () => {
			// Keep polling until ws-inv-data is ready. DDC.pubsub does not
			// retain last-published values, so the at-mount direct read of
			// getPaging() below is what captures state when SSR hydration
			// published before this widget mounted; the subscriptions handle
			// subsequent updates.
			if (window.DDC?.InvData?.srpReady) {
				// Resolve pubsub here, not at hook scope: by the time srpReady
				// is true, window.DDC.pubsub is far more likely to exist.
				const pubsub = window.DDC?.pubsub;
				inventorySubscription = pubsub?.subscribe(
					'ws-inv-data/inventory',
					() => {
						dispatch({
							type: 'INV_DATA_SUCCESS',
							payload: window.DDC.InvData.getPaging()
						});
					}
				);
				requestFailedSubscription = pubsub?.subscribe(
					'ws-inv-data/inventory/request-failed',
					() => {
						dispatch({ type: 'INV_DATA_FAILURE' });
					}
				);
				dispatch({
					type: 'INV_DATA_SUCCESS',
					payload: window.DDC.InvData.getPaging()
				});
				clearInterval(waitForInvDataHandle);
			}
		};
		waitForInvDataHandle = setInterval(checkForInvData, 100);
		return () => {
			clearInterval(waitForInvDataHandle);
			inventorySubscription?.unsubscribe();
			requestFailedSubscription?.unsubscribe();
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};
